export default __webpack_public_path__ + "static/media/Shalendra_Singh_Resume_02.31739e6b.pdf";